// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import mixin  from './mixin';
import _ from 'lodash'
Object.defineProperty(Vue.prototype, '_', { value: _ });
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
import VueProgressiveImage from 'vue-progressive-image'

Vue.use(VueProgressiveImage)
// set default config
VueCookies.config('7d');

Vue.config.productionTip = false
Vue.mixin(mixin);
var platform = require('platform');
/* eslint-disable no-new */
window.Apv = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js